import { render, staticRenderFns } from "./ms-notify.vue?vue&type=template&id=6d339d84&scoped=true&"
import script from "./ms-notify.vue?vue&type=script&lang=js&"
export * from "./ms-notify.vue?vue&type=script&lang=js&"
import style0 from "./ms-notify.vue?vue&type=style&index=0&id=6d339d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d339d84",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QIcon});
